export const PETITES_SET_PETITES = 'PETITES_SET_PETITES';
export const PETITES_UPDATE_ACTIVE_MINI = 'PETITES_UPDATE_ACTIVE_MINI';
